module.exports = __webpack_public_path__ + "static/media/Sample_partner_dash.1e2dad05.png";